<template>
    <div class="pay-ctn">
        <h3>请选择您购买的会员类型</h3>
        <van-tabs :active="memberPermissions[bizType].defaultIndex">
          <template v-if="isIOS">
            <van-tab title="30天">
              <van-cell @click="onSelectAmount('Silver', 'month')" is-link>
                <span>月卡</span>
                <div>
                  <span class="pay-amount">{{168}}元</span>
                </div>
              </van-cell>
            </van-tab>
          </template>
          <template v-else>
            <van-tab v-for="(payOption,index) in payOptions" :name="index" :key="index" :title="payOption.periodDesc.replace('30天', '')">
              <van-cell @click="onSelectAmount(payOption, 'month')" is-link>
                <span>月卡</span>
                <div>
                  <span class="pay-amount">{{Math.floor(payOption.priceDesc * 1)}}元</span>
                </div>
              </van-cell>
              <van-cell @click="onSelectAmount(payOption, 'season')" is-link>
                <span>季卡</span>
                <div>
                  <span class="pay-save">{{Math.floor(payOption.priceDesc * 0.9)}}元/月, 省{{Math.floor(payOption.priceDesc * 3)-Math.floor(payOption.priceDesc * 0.9 * 3)}}元</span>
                  <span class="pay-amount">{{Math.floor(payOption.priceDesc * 0.9 * 3)}}元</span>
                </div>
              </van-cell>
              <van-cell @click="onSelectAmount(payOption, 'year')" is-link>
                <span>年卡</span>
                <div>
                  <span class="pay-save">{{Math.floor(payOption.priceDesc * 0.8)}}元/月, 省{{Math.floor(payOption.priceDesc * 12)-Math.floor(payOption.priceDesc * 0.8 * 12)}}元</span>
                  <span class="pay-amount">{{Math.floor(payOption.priceDesc * 0.8 * 12)}}元</span>
                </div>

              </van-cell>
            </van-tab>
          </template>
        </van-tabs>
        <van-dialog title="确认付款" :show="showDialog" :show-confirm-button="false">
            <div class="pay-confirm">
                <p v-if="isIOS">你购买的是<span class="buy-day">白银会员月卡</span>,需要支付<span class="pay-amount">168元</span></p>
                <p v-else>你购买的是<span class="buy-day">{{payOption.periodDesc}}{{periodMap[period].name}}</span>,需要支付<span class="pay-amount">{{Math.floor(payOption.priceDesc * periodMap[period].monthNum * periodMap[period].discount)}}元</span></p>
                <h4>支付方式</h4>
                <van-radio-group v-model="payType">
                  <template v-if="isIOS">
                    <van-radio name="apple"><van-icon size="2em" :name="applePng" color="#1677FF"/><span class="pay-text">Apple</span></van-radio>
                  </template>

                  <template v-else>
                    <van-radio name="alipay"><van-icon name="alipay" color="#1677FF"/><span class="pay-text">支付宝</span></van-radio>
                    <van-radio name="wechat"><van-icon name="wechat-pay" color="#25AC3B"/><span class="pay-text">微信</span></van-radio>
                  </template>
                </van-radio-group>
                <p class="btn-wrap">
                    <van-button type="default" @click="showDialog=false">取消</van-button>
                    <van-button type="primary" @click="() => isIOS ? doIOSPay(): doPay()">付款</van-button>
                </p>
            </div>
        </van-dialog>
        <van-overlay :show="showOverLay" @click="showOverLay = (payType!=='alipay')">
            <div class="loading-wrapper" v-if="payType === 'alipay'">
                <van-loading v-show="showLoading">正在提交,请稍后</van-loading>
                <div ref="alipayWap" v-html="payData"></div>
            </div>
            <div class="loading-wrapper" v-else>
                <div ref="alipayWap" style="text-align: left">

                    <div class="link-wrap">1.</div>
                    <div style="display: flex;align-items: center;">复制支付链接:<Clipbord :text="payData" show-copy-button="true"/></div>
                    <div style="display: flex;align-items: center;padding-top:1rem;" v-if="payData">或扫码二维码:<vue-qrcode :value="payData"></vue-qrcode></div>
                    <p>2.打开微信，发送已复制链接给任意用户</p>
                    <p>3.微信内点击链接,然后完成微信支付</p>
                    <p class="link-wrap">4.返回APP并点击&nbsp;<van-button size="small" type="primary">完成付款</van-button></p>
                </div>
            </div>
        </van-overlay>
        <div class="member-desc">
          <div>
            <p class="option-name">功能说明:</p>
            <table>
              <thead>
                <tr>
                  <th v-for="(thName,index) in memberPermissions[bizType].columns" :key="index">{{thName}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,rowIndex) in memberPermissions[bizType].datas" :key="rowIndex">
                  <td v-for="(td,index) in row"  :key="index" :style="index > 0 ? 'text-align:center;':''">
                    <template v-if="td===true">
                      <van-icon color="#07c160" name="passed" />
                    </template>

                    <template v-else-if="td===false">
                      <van-icon color="#FF4081" name="close" />
                    </template>
                    <template v-else>
                      {{td}}
                    </template>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>

    </div>
</template>
<style lang="less">
@import "@/app.less";
.pay-ctn{
    h3{
        text-align: left;
        padding-left: 2rem;
    }
    .van-cell__value{
        color: #1c1c1e;
        display: flex;
        justify-content: space-between;
    }
    .pay-confirm{
        text-align: left;
        padding: 0.5rem 1rem;
    }
    .pay-amount{
        color: #00BF8A;
        font-size: 1.1rem;
    }
    .pay-save{
      color: #646566;
      padding-right: 1rem;
    }
    .buy-day{
        font-weight: bold;
    }
    .btn-wrap{
        text-align: center;
        .van-button{
            margin: 0 0.5rem;
        }
    }
    .van-radio{
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .van-dialog__header{
        padding-top: 0.8rem;
        padding-left: 1rem;
        text-align: left;
    }
    .van-radio__label{
        display: flex;
        align-items: center;
    }
    .van-radio__icon--checked .van-icon{
        background-color: #4a4a4a;
        border-color: #4a4a4a;
    }
    .van-icon-alipay,.van-icon-wechat-pay{
        font-size:1.5rem;
    }
    .pay-text{
        padding-left: 0.5rem;
    }
    a{
        color: inherit;
    }

    .clipbord-ctn .link-text{
        width: 16rem;
    }

    .link-wrap{
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
    }

  .member-desc{
    padding: 1rem 1rem 0 1rem;
    text-align: left;
    color: #555;
    .option-name{
      font-weight: bold;
      padding-right: 0.5rem;
    }
  }

  .member-tips li{
    padding: 0.2rem 0;
  }
}

.loading-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #FFFFFF;
    flex-direction: column;
}

</style>
<script>
import {onMounted, ref, nextTick, watch} from "vue";
import {showNotify} from "vant";
import {useRouter} from "vue-router";
import API from "@/api"
import store from "@/store"
import Clipbord from "@/components/Clipbord.vue";
import {getUrlParam} from "@/utils/util";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import applePng from '@/assets/apple.png';

const payOptionTipsMap = {
    bronze: "抢红包+夺宝浮窗(他趣)数据功能",
    silver: "抢红包+夺宝浮窗(他趣 + 梦伴)、历史数据全部功能",
    gold: "文字招募功能",
    paltinum: "抖音私信功能",
    diamond: "文字+红包招募功能",
    honor: "文字+红包+私信招募全部功能",
    king:"招募全部功能+家族管家",
    empire:"招募全部功能+家族管家",
};

const memberPermissions = {
  "DataMember":{
    "columns":["功能", "白银", "皇帝", "备注"],
    "defaultIndex": 0,
    "datas": [
      ["抢红包", true, true, "-"],
      ["数据悬浮窗", true, true, "-"],
      ["礼物记录", true, true, "-"],
      ["历史数据点位", true, true, "-"],
      ["电脑版数据", false, true, "-"],
      ["会员共享", false, true, "-"],
      ["数据定制", false, true, "-"],
    ]
  },
  "FamilyMember":{
    "columns":["功能", "黄金", "钻石", "星耀", "王者", "备注"],
    "defaultIndex": 0,
    "datas": [
      ["家族文字招募", true, true, true, true, "-"],
      ["家族红包招募", false, true, true, true, "-"],
      ["家族私信招募", false, false, true, true, "-"],
      ["家族管家", false, false, false, true, "-"],
      ["家族数据", false, false, false, true, "-"]
    ]
  },
  "DoumiMember":{
    "columns":["功能", "铂金", "备注"],
    "defaultIndex": 0,
    "datas": [
      ["抖音私信", true, "-"]
    ]
  },
};

const periodMap = {
  "month": {
    "name": "月卡",
    "discount": 1,
    "monthNum": 1,
  },
  "season": {
    "name": "季卡",
    "discount": 0.9,
    "monthNum": 3,
  },
  "year": {
    "name": "年卡",
    "discount": 0.8,
    "monthNum": 12,
  },
}

const isIOS = false;///(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);


export default{
    name: "MemberPay",
    components: {Clipbord,VueQrcode},
    setup(){
        const showDialog = ref(true);
        const payType = ref(isIOS ? "apple" : "alipay");
        const payOptions = ref([]);
        const showLoading = ref(false);
        const showOverLay = ref(false);
        const payMessage = ref("等待支付中...");
        const router = useRouter();
        const textArea = ref(null);

        const payOption = ref({
            buyType:'',
            periodDesc:'',
            priceDesc:'',
            bizType: 'DataMember'
        });

        const payData = ref("");
        const bizType = store.userStore().getBizType();
        onMounted(async () => {
            const response = await API.pay.getPayOptions(bizType);

            if(response.success) {
                Object.assign(payOptions.value, response.data);
                // payOptions.value.reverse();
                Object.assign(payOption.value, payOptions.value[memberPermissions[bizType].defaultIndex])
            }
        });

        const getPayOptionTip = (payOption) => {
          return payOptionTipsMap[payOption.buyType] || payOption.tips;
        }


        return {
            payOption: payOption,
            period: "month",
            payType: payType,
            bizType: bizType,
            showDialog: showDialog,
            payOptions: payOptions,
            payData: payData,
            showLoading: showLoading,
            showOverLay,
            payMessage,
            textArea,
            periodMap,
            isIOS,
            applePng,
            getPayOptionTip,
            memberPermissions,
            routeTo:(path) => router.push(path)
        }
    },
    methods:{
        onSelectAmount(payOption, period){
            this.payOption = payOption;
            this.period = period;
            this.showDialog = true;
        },
        onSelectPayMethod(type){
            this.payType = type;
        },
        async doPay(){

            //调用支付
            const userStore = store.userStore();
            const deviceId = userStore.getDeviceId();
            this.showLoading = true;
            this.showOverLay = true;
            const router = useRouter();
            const routeTo = (path) => router.push(path)

          const response = await API.pay.doCreateMemberOrder({
                deviceId,
                amount: this.payOption.priceDesc,
                buyType: this.payOption.buyType,
                payType: this.payType,
                period: this.period,
                bizType: this.bizType
            });

            if(!response.success){
                showNotify({type:"warning", message: response.errorMsg});
                return;
            }

            const payOrder = response.data;
            this.payData = payOrder.formData;

            if(this.payType === "alipay"){
                this.showDialog = false;

                nextTick(() => {
                    this.showLoading = true;
                    document.forms[0].submit();
                    this.payMessage = "支付成功";
                });
            }else{
                this.showDialog = false;
                this.showLoading = true;
            }

            //定时刷新支付状态
            let timer = null;
            let lock = false;
            let counter = 3;
            let paySuccess = false;

            timer = setInterval(() => {
                if(lock){
                    return;
                }

                if(paySuccess){
                    this.payMessage = "支付成功,正在跳转:" + counter;
                    if(counter <= 0){
                        clearInterval(timer);
                        if(userStore.user.bizType === "family"){
                          routeTo("/family-config");
                        }else if(userStore.user.bizType === "doumi"){
                          routeTo("/doumi-config");
                        }else{
                          routeTo("/data-desc");
                        }
                    }
                    counter--;
                    return;
                }
                lock = true;
                API.pay.queryPayOrder(payOrder.tradeOrderNo).then((queryResponse) => {
                    if(queryResponse.success && queryResponse.data.tradeStatus === 1){
                        paySuccess = true;
                        showNotify({type:"success", message: "支付成功"});
                        this.payMessage = "支付成功,正在跳转:" + counter;
                        //支付成功
                      userStore.getUserInfo(deviceId);
                    }
                }).finally(() => {
                    lock = false;
                });

            },500);

        },
        async doIOSPay(){
          const userStore = store.userStore();
          const deviceId = userStore.getDeviceId();
          this.showLoading = true;
          this.showOverLay = true;
          const router = useRouter();
          const routeTo = (path) => router.push(path)

          const response = await API.pay.doCreateMemberOrder({
            deviceId,
            amount: this.payOption.priceDesc,
            buyType: this.payOption.buyType,
            payType: this.payType,
            period: this.period,
            bizType: this.bizType
          });

          if(!response.success){
            showNotify({type:"warning", message: response.errorMsg});
            return;
          }

          const payOrder = response.data;
          this.payData = payOrder.formData;



          window.flutter_inappwebview.callHandler("purchase", {productId: "silver", orderInfo: payOrder.tradeOrderNo}).then(function(response){
            if(response.code === 0){
              showNotify({type:"success", message: "支付成功"});
              userStore.getUserInfo(deviceId);
              routeTo("/data-desc");
            }else{
              showNotify({type:"warning", message: response.message});
            }
          });

          //定时刷新支付状态
          let timer = null;
          let lock = false;
          let counter = 3;
          let paySuccess = false;

          timer = setInterval(() => {
            if(lock){
              return;
            }

            if(paySuccess){
              this.payMessage = "支付成功,正在跳转:" + counter;
              if(counter <= 0){
                clearInterval(timer);
                if(userStore.user.bizType === "family"){
                  routeTo("/family-config");
                }else if(userStore.user.bizType === "doumi"){
                  routeTo("/doumi-config");
                }else{
                  routeTo("/data-desc");
                }
              }
              counter--;
              return;
            }
            lock = true;
            API.pay.queryPayOrder(payOrder.tradeOrderNo).then((queryResponse) => {
              if(queryResponse.success && queryResponse.data.tradeStatus === 1){
                paySuccess = true;
                showNotify({type:"success", message: "支付成功"});
                this.payMessage = "支付成功,正在跳转:" + counter;
                //支付成功
                userStore.getUserInfo(deviceId);
              }
            }).finally(() => {
              lock = false;
            });

          },1000);
        }
    }
}
</script>
